"use client"

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={`${className} custom-arrow custom-prev-arrow`}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <i className="fas fa-chevron-left"></i>
        </div>
    )
}

export default SamplePrevArrow
